import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { color } from "../../../styles/color";
import { MatchPlace } from "../../../styles/MatchPage";
import { CaretDownOutlined, EnterOutlined } from "@ant-design/icons";
import type { Obj } from "../../../client_types";

interface IProps {
  city: string;
  club: Obj[];
  active: number | null;
  subMenu: number | null;
  location: Obj[];
  cityOnClick: (cityID: number, i: number) => void;
  submenuOnClick: (
    gid: number,
    name: string,
    nickname: string,
    i: number
  ) => void;
}

const MatchLocation = ({
  club,
  active,
  city,
  location,
  subMenu,
  cityOnClick,
  submenuOnClick,
}: IProps) => (
  <MatchPlace>
    <div className="county">{city == null ? "选择地区" : city}</div>
    {location === null ? (
      <div
        className="matchWrapper"
        style={{ padding: "1rem", margin: "0 -1rem" }}
      >
        查无鸽会
      </div>
    ) : null}
    {location &&
      location.map((d, i) => (
        <div
          className="matchInfo"
          key={uuidv4()}
          style={{ display: "flex", flexFlow: "column nowrap" }}
        >
          <div className="matchWrapper">
            <div className="matches" onClick={() => cityOnClick(d.CityID, i)}>
              <span>{d.CityName}</span>
              <div>
                <span>{d.CountNumber}</span>
                <CaretDownOutlined
                  style={{
                    color: `${color.primaryBlue}`,
                    marginLeft: ".5rem",
                    transition: "all .3s ease-out",
                  }}
                />
              </div>
            </div>
            {subMenu === i
              ? club &&
                club.map((d: Obj, i: number) => (
                  <div
                    className="subMenu"
                    style={{
                      backgroundColor:
                        active === i ? `${color.markedSecondary}` : "",
                      color: active === i ? `white` : "",
                    }}
                    onClick={() => submenuOnClick(d.Gid, d.Name, d.Nickname, i)}
                    key={uuidv4()}
                  >
                    <EnterOutlined style={{ transform: "scaleX(-1)" }} />
                    {d.Nickname}
                  </div>
                ))
              : null}
          </div>
        </div>
      ))}
  </MatchPlace>
);

export default MatchLocation;
